<div class="content-header" *ngIf="display">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-9">
        <h1 class="m-0">
          {{ header }}
          <small>{{ description }}</small>
        </h1>
      </div>
      <div class="col-sm-3">
        <ol class="breadcrumb float-sm-right">
          <ng-container *ngFor="let item of levels">
            <li *ngIf="!item.active"  class="breadcrumb-item" [class.active]="item.active">
              <a [routerLink]="item.link">
                <i *ngIf="item.icon !=null" class="fas fa-{{item.icon}}"></i> {{ item.title }}
              </a>
            </li>
            <li *ngIf="item.active"  class="breadcrumb-item" [class.active]="item.active">
              
              <i *ngIf="item.icon !=null" class="fas fa-{{item.icon}}"></i> {{ item.title }}
              
            </li>
          </ng-container>
        </ol>
      </div>
    </div>
  </div>
</div>
